import React from 'react';
import useAppInstallation from '../hooks/useAppInstallation';

function SmartphoneIcon() {
  return (
    <svg className="h-5 w-5 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  );
}

/** Das „Teilen"-Symbol von Safari (Quadrat mit Pfeil nach oben), damit iOS-Nutzer es in der Leiste wiederfinden. */
function ShareIcon() {
  return (
    <svg className="inline h-4 w-4 align-text-bottom" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7" /><polyline points="16 6 12 2 8 6" /><line x1="12" y1="2" x2="12" y2="15" />
    </svg>
  );
}

/**
 * Hinweis, die Anwendung als App zu installieren. Erscheint nur, wenn die
 * Installation tatsächlich möglich ist (siehe useAppInstallation) und wurde
 * nicht bereits installiert oder vom Nutzer geschlossen.
 *
 * `dauerhaft`: ohne Schließen-Knopf und unabhängig davon, ob der Hinweis schon
 * einmal geschlossen wurde (für das Profil).
 */
function AppInstallHinweis({ dauerhaft = false, className = 'mt-6' }) {
  const { modus, installieren, schliessen } = useAppInstallation({ dauerhaft });
  if (!modus) return null;

  return (
    <div className={`flex items-start gap-3 rounded-lg border border-brand-200 bg-brand-50 px-4 py-3 text-brand-700 ${className}`}>
      <SmartphoneIcon />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">RWK Manager als App installieren</p>
        {modus === 'ios' ? (
          <p className="text-sm mt-0.5">
            Tippe in Safari auf <strong className="font-semibold">Teilen</strong> <ShareIcon /> und
            wähle <strong className="font-semibold">„Zum Home-Bildschirm"</strong>, um den RWK Manager
            wie eine App direkt vom Startbildschirm zu öffnen.
          </p>
        ) : (
          <>
            <p className="text-sm mt-0.5">
              Installiere den RWK Manager auf deinem Gerät, um ihn wie eine App direkt vom Startbildschirm zu öffnen.
            </p>
            <button type="button" onClick={installieren} className="btn btn-primary btn-sm mt-2">
              Installieren
            </button>
          </>
        )}
      </div>
      {!dauerhaft && (
        <button
          type="button"
          onClick={schliessen}
          className="shrink-0 rounded p-1 hover:bg-brand-100 transition-colors"
          title="Hinweis schließen"
          aria-label="Hinweis schließen"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default AppInstallHinweis;
